import moment from 'moment'
const SysUtils = {
  debug (obj) {
    console.log(this.name + ':' + JSON.stringify(obj))
  },
  showInfo (msg) {
    window.toasted.show(msg, {
      position: 'top-center',
      duration: 2000,
      type: 'info'
    })
  },
  showError (msg) {
    window.toasted.show(msg, {
      position: 'top-center',
      duration: 2000,
      type: 'error'
    })
  },
  showSuccess (msg) {
    window.toasted.show(msg, {
      position: 'top-center',
      duration: 2000,
      type: 'success'
    })
  },
  showToasted (msg, type = 'success') {
    window.toasted.show(msg, {
      position: 'top-center',
      duration: 2000,
      type: type
    })
  },
  copyObjectValue (target, source) {
    $.extend(true, target, source)
    return target
  },
  cloneObject (source) {
    let target
    if (source instanceof Array) {
      target = []
      $.extend(true, target, source)
    } else if (source instanceof Object) {
      target = {}
      $.extend(true, target, source)
    } else {
      target = source
    }
    return target
  },
  convStringToRangeDate: (rangeStr) => {
    if (SysUtils.isEmpty(rangeStr)) {
      return null
    }
    let arr = rangeStr.match(/(\d{4}\/\d{2}\/\d{2})(\s-\s)(\d{4}\/\d{2}\/\d{2})$/)
    if (arr === null || arr.length !== 4) {
      return null
    }
    return {startDate: arr[1], endDate: arr[3]}
  },
  convRangeDateString: (rangeObj) => {
    if (!rangeObj) {
      return ''
    } else {
      return moment(rangeObj.startDate).format('YYYY/MM/DD') + ' - ' + moment(rangeObj.endDate).format('YYYY/MM/DD')
    }
  },
  getRandnum () {
    return Math.floor(Math.random() * 9999)
  },
  formatDate: (value, format) => {
    return moment(value, 'YYYY/MM/DD').format(format)
  },
  checkDateFormat (value, format) {
    return (moment(value, format).format(format) === value)
  },
  convSelectArrToMap: (selectArr) => {
    var map = {}
    selectArr.forEach(function (obj1) {
      if ('children' in obj1) {
        obj1.children.forEach(function (obj2) {
          map[obj2.id] = obj2.text
        })
      } else {
        map[obj1.id] = obj1.text
      }
    })
    return map
  },
  getDate (addDay) {
    return moment().add(addDay, 'days').format('YYYY/MM/DD')
  },
  convDbArrToSelectArr: function (dbArr, idCol, valCol, grpCol) {
    let labelFunc = function (obj) {
      return obj[valCol]
    }
    if ((typeof valCol) === 'function') {
      labelFunc = valCol
    }

    if (grpCol !== undefined) {
      let selMap = {}
      dbArr.forEach(function (obj) {
        if (!(obj[grpCol] in selMap)) {
          selMap[obj[grpCol]] = {text: obj[grpCol],
            children: []
          }
        }
        selMap[obj[grpCol]].children.push({id: obj[idCol], text: labelFunc(obj), grp: obj[grpCol]})
      })
      return $.map(selMap, function (value, index) { return value })
    } else {
      let selArr = []
      dbArr.forEach(function (obj) {
        selArr.push({id: obj[idCol], text: labelFunc(obj)})
      })
      return selArr
    }
  },
  createHideString: function (ch, length) {
    let label = ''
    for (let i = 0; i < length; i++) {
      label = label + ch
    }
    return label
  },
  existsKey (arr, key) {
    if (arr) {
      return (key in arr)
    } else {
      return false
    }
  },
  isEmpty: function (value) {
    if (value === undefined || value === null || value === '') {
      return (true)
    }
    if (value instanceof Array) {
      return (value.length === 0)
    }
    if (value instanceof Object) {
      return (Object.keys(value).length === 0)
    }
  },
  createTableConfig (config) {
    let listFields = []
    Object.keys(config.fields).forEach(function (key) {
      let val = config.fields[key]
      val.data = key
      if (val.listView) {
        listFields.push(val)
      }
    })
    config.listFields = listFields
    return config
  },
  objectEquals (a, b) {
    if (a === b) {
      return true
    }
    return JSON.stringify(a) === JSON.stringify(b)
  }
}
export default SysUtils
